const gitinfo = {
  "commit": "62768b82cff22707c80560cec924a65efc4d9db2",
  "abbreviated_commit": "62768b8",
  "tree": "c584c6bdecb918ecb7d663125b88f1ebf7021e15",
  "abbreviated_tree": "c584c6b",
  "parent": "58d53b9ef9a7a6e2ddb5a73cdbc3c8534f9b1560",
  "abbreviated_parent": "58d53b9",
  "refs": "HEAD -> main, origin/main, origin/HEAD",
  "encoding": "",
  "commit_notes": "",
  "verification_flag": "N",
  "signer": "",
  "signer_key": "",
    "date": "Sun, 20 Apr 2025 20:25:51 -0500"
 }
export default gitinfo;